const styles = {
  colors : {
    PRIMARY_500 : '#82C341',
    PRIMARY_700 : '#5F9F2F',
    BLACK_COOL : '#E4EAEB',
    CAPTION : '#9C9C9C',
    VIOLET : '#725E9C',
    BLUE : '#5C8F94',
    ORANGE_300 : '#EBA45E',
    ORANGE_400 : '#E69849',
    GREEN : '#789764'
  }
}

export default styles;